import { useEffect, useState } from "react";

const LINES: { t: number; text: string; cls?: "ok" | "err" }[] = [
  { t: 0,    text: "[boot] shadowargus console v0.1.0" },
  { t: 90,   text: "[boot] vfs mounting ........... ok", cls: "ok" },
  { t: 180,  text: "[boot] auth.protonvpn ......... handshake" },
  { t: 320,  text: "[boot] auth.protonvpn ......... up", cls: "ok" },
  { t: 410,  text: "[boot] aws.region ............. us-east-1" },
  { t: 470,  text: "[boot] stepfn.cascade ......... ready", cls: "ok" },
  { t: 560,  text: "[boot] registry: 21 apis loaded" },
  { t: 640,  text: "[boot] orange-pi worker ....... ssm/managed" },
  { t: 720,  text: "[boot] console ready" },
];

export function Boot({ onDone }: { onDone: () => void }) {
  const [visible, setVisible] = useState<number>(0);
  const [gone, setGone] = useState(false);

  useEffect(() => {
    const timers = LINES.map((l, i) => setTimeout(() => setVisible(i + 1), l.t));
    const close = setTimeout(() => { setGone(true); onDone(); }, 950);
    return () => { timers.forEach(clearTimeout); clearTimeout(close); };
  }, [onDone]);

  return (
    <div className={`boot${gone ? " gone" : ""}`}>
      <div>
        {LINES.slice(0, visible).map((l, i) => (
          <span key={i} className={`line${l.cls ? " " + l.cls : ""}`}>{l.text}</span>
        ))}
        {visible < LINES.length && <span className="caret" />}
      </div>
    </div>
  );
}
